module.exports = __webpack_public_path__ + "static/media/newlogogreen.e90aedc6.png";